// import "../css/style.css";
import "../scss/styles.scss";

import bootstrap from "bootstrap/dist/js/bootstrap.bundle.min.js";
import fullpage from "fullpage.js/dist/fullpage.min.js";

import Pqp from "./Pqp.js";
import AnimatedText from "./AnimatedText.js";
import { initPortfolioCalculator } from "./portfolio-calculator.js";
import { initPortfolioFunds } from "./portfolio-funds.js";
import Appear from "./Appear";
import { initLocationForms } from "./LocationForms.js";
import { initNavBannerEu } from "./NavBannerEu.js";
import initCardsSlider from "./components/CardsSlider.js";
import { getCookieByName, setButtonsWidth } from "./helpers/helpers.js";

export default class Main {
	constructor() {
		let bd = document.getElementsByTagName("html")[0];
		let app = document.querySelector(".app");
		let page = app.dataset.page;
		this.bd = bd;
		this.page = page;
		Main.that = this;
		this.ats = new Array();
		this.backs = new Array();
		this.isScrolling = false;
		this.pageData;

		// this.getOriginalBackground();
		$(".js-scrollto").on("click", (e) => {
			window.scrollTo({
				top: 0,
				behavior: "smooth",
			});
		});

		$(".js-download").on("click", (e) => {
			let download = $(".js-come-funziona").offset().top;
			$("html, body").animate(
				{
					scrollTop: download - 200,
				},
				500
			);
		});

		$(window).scroll(function () {
			var s = $(window).scrollTop();
			if (s > 2) {
				$("body").addClass("header--sticky");
			}

			if (s > $(window).height() && $(window).width() > 767) {
				$("body").addClass("header--sticky-has-bg");
			} else {
				$("body").removeClass("header--sticky");
				$("body").removeClass("header--sticky-has-bg");
			}
		});

		if (document.querySelector(".js-location-form")) {
			initLocationForms();
		}

		const bannerEU = document.querySelector(".js-nav-banner-eu");
		if (bannerEU) {
			initNavBannerEu(bannerEU);
		}

		switch (this.page) {
			case "home":
				{
					initPortfolioCalculator();
				}
				break;

			case "single-portfolio":
				{
					initPortfolioFunds();
				}
				break;
		}
	}

	bindEvents() {
		$(".js-toggle-class").bind("click", function (e) {
			e.preventDefault();
			var $this = $(this);
			var tg = $this.attr("href") || $this.attr("data-target");
			var name = $this.attr("data-name") || "";
			if (tg) {
				$(tg).toggleClass(name);
				$this.toggleClass("toggled");
			}
		});

		if (this.page === "home") {
			$(".js-scrollto").bind("click", function (e) {
				e.preventDefault();
				var $this = $(this);
				var tg = $this.attr("href") || $this.attr("data-target");
				if (tg) {
					var scrollTop = $(tg).position().top;
					$("html, body").animate({
						scrollTop,
					});
				}
			});

			// init swiper-cards
			if ($(".js-swiper-cards")) {
				initCardsSlider();
			}
		}
	}

	hideLoading() {
		jQuery(".js-preloader").hide();

		if (!Pqp.isMobile()) {
			var lotties = jQuery(".app").find("lottie-player");
			for (let x = 0; x < lotties.length; x++) {
				lotties[x].play();
			}
		}
	}

	initAppear(appear) {
		appear.init();
	}

	render(pageData = null) {
		/**
		 * patch magazine btns width
		 */
		if (document.querySelector(".filter-toolbar")) {
			let resizing;
			const btns = document.querySelectorAll(".filter-btn");
			setButtonsWidth(btns);
			window.addEventListener("resize", (e) => {
				clearTimeout(resizing);
				setButtonsWidth(btns);
			});
		}

		if (this.page === "home") {
			if (false) {
				jQuery(".js-preloader").hide();
				this.bindEvents();
				this.buildFrames();
				this.showFirstFrame();
				this.setWheelListeners();
			} else {
				let a = jQuery(".js-appear");
				for (let x = 0; x < a.length; x++) {
					let mc = jQuery(a[x]);

					let appear = new Appear(mc);
					if (appear.elementInViewport2(mc)) {
						mc.css("opacity", 1);
					} else {
						mc.css("opacity", 0);
					}

					setTimeout(this.initAppear.bind(this, appear), 1000);
				}

				this.bindEvents();
				jQuery("#fp-nav").hide();
				setTimeout(this.hideLoading.bind(this), 1000);
			}

			return;
		}

		jQuery(".js-preloader").hide();
		this.bindEvents();
		Main.that.wwidth = jQuery(window).width();
		jQuery(window).on("resize", Main.that.onResize.bind(Main.that));

		/* JS COMUNI */
		if (!("ontouchstart" in document.documentElement)) {
			document.documentElement.classList.add("no-touch");
		} else {
			document.documentElement.classList.add("touch");
		}

		setPlugins();
		setAjaxFilter();

		function setPlugins() {
			Main.that.whenRemoveLoader();
			Main.that.getNavigation();

			//SWIPER
			new Swiper(".swiper-pf", {
				slidesPerView: "auto",
				centeredSlides: true,
				loop: true,
				slideToClickedSlide: true,
				pagination: {
					el: ".swiper-pf .swiper-pagination",
					clickable: true,
				},
				breakpoints: {
					768: {
						spaceBetween: 80,
					},
				},
			});

			new Swiper(".team-swiper", {
				slidesPerView: 2,
				watchOverflow: true,
				spaceBetween: 30,
				breakpoints: {
					768: {
						slidesPerView: 2.5,
						spaceBetween: 50,
					},
					993: {
						slidesPerView: 3,
						spaceBetween: 70,
					},
				},
			});

			let pressAreaSwiper;
			if ($(window).width() < 821) {
				pressAreaSwiper = new Swiper(".press-area-swiper", {
					slidesPerView: 1.5,
					spaceBetween: 30,
					slidesPerGroup: 1,
					centeredSlides: true,
					breakpoints: {
						768: {
							slidesPerView: 2.5,
							slidesPerGroup: 1,
						},
					},
					pagination: {
						el: ".press-area-swiper .swiper-pagination",
						clickable: true,
					},
				});
			}
			window.addEventListener("resize", (e) => {
				if ($(window).width() < 821) {
					console.log(pressAreaSwiper);
					if (
						!$(".press-area-swiper").hasClass("swiper-container-initialized")
					) {
						pressAreaSwiper = new Swiper(".press-area-swiper", {
							slidesPerView: 1.5,
							spaceBetween: 30,
							slidesPerGroup: 1,
							centeredSlides: true,
							breakpoints: {
								768: {
									slidesPerView: 2.5,
									slidesPerGroup: 1,
								},
							},
							pagination: {
								el: ".press-area-swiper .swiper-pagination",
								clickable: true,
							},
						});
					}
				} else {
					pressAreaSwiper.destroy();
					$(".swiper-pagination", ".press-area-swiper").removeClass(
						"swiper-pagination-clickable"
					);
					$(".swiper-pagination", ".press-area-swiper").children().remove();
				}
			});

			new Swiper(".steps-swiper", {
				slidesPerView: "auto",
				watchOverflow: true,
				spaceBetween: 0,
				breakpoints: {
					768: {
						slidesPerView: 5,
						spaceBetween: 30,
					},
				},
			});

			new Swiper(".magazine-swiper", {
				slidesPerView: 1,
				watchOverflow: true,
				spaceBetween: 16,
				pagination: {
					el: ".magazine-swiper .swiper-pagination",
					clickable: true,
				},
				navigation: {
					nextEl: ".magazine-swiper .swiper-button-next",
					prevEl: ".magazine-swiper .swiper-button-prev",
				},
			});

			new Swiper(".related-swiper", {
				slidesPerView: 1,
				watchOverflow: true,
				spaceBetween: 16,
				breakpoints: {
					768: {
						slidesPerView: 2,
					},
				},
				pagination: {
					el: ".related-swiper .swiper-pagination",
					clickable: true,
				},
			});

			//BOOTSTRAP
			var tooltipTriggerList = [].slice.call(
				document.querySelectorAll('[data-bs-toggle="tooltip"]')
			);
			tooltipTriggerList.map(function (tooltipTriggerEl) {
				return new bootstrap.Tooltip(tooltipTriggerEl);
			});
		}

		function setAjaxFilter() {
			$(".filter-btn").bind("click", function () {
				$(".filter-btn").removeClass("on");
				$(this).addClass("on");
				$(".posts-list").html("");
				$(".posts-container").addClass("loading");
				beewise_params.current_page = 1;

				$.ajax({
					type: "POST",
					url: beewise_params.ajaxurl,
					dataType: "html",
					data: {
						action: "filter_projects",
						category: $(this).data("slug"),
						pagination: beewise_params.current_page,
						blog_id: pageData?.data?.blog_id,
						lang: getCookieByName("wp-wpml_current_language"),
					},
					success: function (res) {
						$(".posts-container").removeClass("loading");
						$(".posts-list").html(res);
						if (beewise_params.current_page != beewise_params.max_page) {
							$(".load-more-btn").show();
						} else {
							$(".load-more-btn").hide();
						}
					},
				});
			});

			$(".load-more-btn").bind("click", function () {
				$(".posts-container").addClass("loading");
				var category = $(".filter-btn.on").data("slug");
				beewise_params.current_page++;
				console.log({
					blog_id: pageData?.data?.blog_id,
					lang: getCookieByName("wp-wpml_current_language"),
				});
				$.ajax({
					type: "POST",
					url: beewise_params.ajaxurl,
					dataType: "html",
					data: {
						action: "filter_projects",
						category: category,
						pagination: beewise_params.current_page,
						blog_id: pageData?.data?.blog_id,
						lang: getCookieByName("wp-wpml_current_language"),
					},
					success: function (res) {
						$(".posts-container").removeClass("loading");
						$(".posts-list").append(res);
						if (beewise_params.current_page == beewise_params.max_page) {
							$(".load-more-btn").hide();
						}
					},
				});
			});
		}
	}

	initAnimations() {
		if (!Pqp.isMobile()) {
			let tableCell = jQuery(".fp-tableCell");

			if (tableCell.length > 0) {
				let mc = jQuery(
					"<div class='to-init animated-background js-background'></div>"
				);
				tableCell.parent().prepend(mc);
			} else {
				requestAnimationFrame(this.initAnimations.bind(this));
			}
		}
	}

	getOriginalBackground() {
		let tmp = jQuery(".section");
		for (let x = 0; x < tmp.length; x++) {
			this.backs.push(jQuery(tmp[x]).css("background"));
		}
	}

	animateBackground(blockOrigin, blockDestination) {
		let origin = blockOrigin.index;
		let destination = blockDestination.index;
		let colorb = jQuery(blockDestination.item).css("background");

		let mc = jQuery(".js-background", jQuery(blockDestination.item));
		if (mc.hasClass("to-init")) {
			mc.css("background", colorb);
			mc.removeClass("to-init");
		}

		mc.css("opacity", 0);

		if (destination < origin) {
			jQuery(blockDestination.item).css(
				"background",
				this.backs[destination + 1]
			);
		} else {
			jQuery(blockDestination.item).css(
				"background",
				this.backs[destination - 1]
			);
		}

		mc.width((jQuery(window).width() / 4) * 2);
		mc.css("left", jQuery(window).width() / 4);
		mc.css("height", 1);

		this.lastParms = [jQuery(blockDestination.item), mc, colorb, destination];

		if (destination < origin) {
			mc.css("top", jQuery(blockDestination.item).height());
			let endValue = jQuery(blockDestination.item).height();

			this.lastTween = TweenMax.to(mc, 0.5, {
				delay: 0.45,
				height: endValue,
				top: 0,
				width: jQuery(window).width(),
				left: 0,
				ease: Power1.easeIn,
				onStart: this.unhideBack.bind(this, mc),
			});
		} else {
			mc.css("top", 0);
			let endValue = jQuery(blockDestination.item).height();

			this.lastTween = TweenMax.to(mc, 0.5, {
				delay: 0.45,
				height: endValue,
				width: jQuery(window).width(),
				left: 0,
				ease: Power1.easeIn,
				onStart: this.unhideBack.bind(this, mc),
			});
		}
	}

	unhideBack(mc) {
		mc.css("opacity", 1);
	}

	checkAutoScroll() {
		this.enableReactivate = true;
		this.scTop = jQuery(window).scrollTop();
		requestAnimationFrame(this.checkIfReactivate.bind(this));
	}

	checkIfReactivate() {
		if (this.enableReactivate) {
			let st = jQuery(window).scrollTop();
			if (st < this.scTop) {
				fullpage_api.setAutoScrolling(true);
				jQuery(".section").css("opacity", 1);
			} else {
				requestAnimationFrame(this.checkIfReactivate.bind(this));
			}
		}
	}

	getNavigation() {
		let nav = jQuery("#fp-nav");
		jQuery("li", nav).on("click", this.clickedNavigation.bind(this));
	}

	clickedNavigation() {
		fullpage_api.setAutoScrolling(true);
		jQuery(".section").css("opacity", 1);
		this.enableReactivate = false;
	}

	prepareAnimateImage(origin, destination) {
		let mc = jQuery(".js-to-animate-lr", jQuery(destination.item));

		mc.css("opacity", 0);
		jQuery(".js-to-animate-lr", jQuery(destination.item)).removeClass(
			"slideLeftReturn"
		);

		mc = jQuery(".js-to-animate-rl", jQuery(destination.item));
		mc.css("opacity", 0);
		jQuery(".js-to-animate-rl", jQuery(destination.item)).removeClass(
			"slideRightReturn"
		);
	}

	animateImages(destination) {
		let mc = jQuery(".js-to-animate-lr", jQuery(destination.item));
		if (mc.length > 0) {
			TweenMax.to(mc, 0.5, {
				opacity: 1,
			});
			mc.addClass("slideLeftReturn");
		}

		mc = jQuery(".js-to-animate-rl", jQuery(destination.item));
		if (mc.length > 0) {
			TweenMax.to(mc, 0.5, {
				opacity: 1,
			});
			mc.addClass("slideRightReturn");
		}
	}

	prepareItemInAlpha(origin, destination) {
		jQuery(".js-to-appear", jQuery(destination.item)).css("opacity", 0);
	}
	showItemInAlpha(destination) {
		let mcs = jQuery(".js-to-appear", jQuery(destination.item));
		if (mcs.length > 0) {
			TweenMax.to(mcs, 0.5, {
				delay: Main.DELAY_INIZIALE_ANIMAZIONE_APPEAR,
				opacity: 1,
			});
		}
	}

	animateText(destination) {
		let mc = jQuery(destination.item);
		let texts = jQuery(".js-animated-text", mc);

		let c = 0;
		let delay = -1;
		let at;
		for (let x = texts.length - 1; x >= 0; x--) {
			if (delay === -1) {
				delay = Main.DELAY_INIZIALE_ANIMAZIONE_TESTO + 250 * c;
			} else {
				delay = at.totalDelay;
			}
			at = new AnimatedText(jQuery(texts.get(x)), delay);
			c++;
			at.init();
			this.ats.push(at);
		}
	}

	killAnimation(origin) {
		for (let x = 0; x < this.ats.length; x++) {
			this.ats[x].destroy();
		}
		this.ats = new Array();
	}

	prepareAnimatedText(destination) {
		let mc = jQuery(destination.item);
		jQuery(".js-animated-text", mc).css("opacity", 0);
	}

	whenRemoveLoader() {
		jQuery(".js-preloader").hide();
	}

	onResize() {
		let w = jQuery(window).width();
		if (w !== this.wwidth) {
			this.wwidth = w;
			if (this.lastTween) {
				let el = jQuery(this.lastTween._targets[0]);
				TweenMax.killTweensOf(el);
				el.width(w);
				el.height(jQuery(window).width());
				el.css({
					left: 0,
					top: 0,
				});
			}
		}
	}

	getParameterByName(name) {
		var match = new RegExp("[?&]" + name + "=([^&]*)").exec(
			window.location.search
		);
		return match && decodeURIComponent(match[1].replace(/\+/g, " "));
	}

	buildFrames() {
		let a = jQuery(".section");
		this.sections = new Array();
		for (let x = 0; x < a.length; x++) {
			let section = jQuery(a[x]);
			section.addClass("fp-section");
			section.addClass("fp-table");
			section.css("position", "absolute");
			section.css("z-index", x * 100 + 100);

			let container = jQuery("<div class='fp-tableCell'></div");
			let children = section.children();
			section.append(container);
			container.append(children);
			jQuery(".js-patch-pqp").css("min-height", "20vh");
			let gate = jQuery("<div></div");
			jQuery(".hp-fullpage").append(gate);
			gate.append(section);
			gate.css("width", "100%");
			gate.css("position", "absolute");
			gate.css("z-index", x * 100 + 100);
			gate.css("overflow", "hidden");
			gate.attr("id", "frame" + x);
			this.sections.push(gate);
		}
		this.setHeigths();
		jQuery(window).on("resize.slides", this.setHeigths.bind(this));
	}

	setHeigths() {
		for (let x = 0; x < this.sections.length; x++) {
			let gate = this.sections[x];
			gate.height(jQuery(window).height());
			let section = jQuery(".section", gate);
			section.height(jQuery(window).height());
			jQuery(".fp-tableCell", section).height(jQuery(window).height());
		}
	}

	showFirstFrame() {
		this.currentFrame = 0;
		for (let x = 1; x < this.sections.length; x++) {
			this.sections[x].hide();
		}
		this.updatePallini();
		this.preparaSlide(
			this.sections[this.currentFrame],
			this.sections[this.currentFrame]
		);
		this.attivaSlide(
			this.sections[this.currentFrame],
			this.sections[this.currentFrame]
		);
	}

	updatePallini(next = -1) {
		let pallini = jQuery("li", jQuery(".js-nav"));
		for (let x = 0; x < pallini.length; x++) {
			let pallino = jQuery(pallini[x]);
			let cmp = next;
			if (next === -1) {
				cmp = this.currentFrame;
			}
			if (x === cmp) {
				jQuery("a", pallino).addClass("active");
			} else {
				jQuery("a", pallino).removeClass("active");
			}
			jQuery("a", pallino).off("click");
			jQuery("a", pallino).on("click", this.gotoSlide.bind(this, x));
		}
		$(".js-go-download").on(
			"click",
			this.gotoSlide.bind(this, pallini.length - 1)
		);
	}

	setWheelListeners() {
		jQuery(window).on("mousewheel", this.onWheel.bind(this));
	}

	onWheel(e) {
		if (this.isScrolling) {
			return;
		}
		let value = Math.abs(e.originalEvent.deltaY);
		if (value >= 100 && Math.floor(value) === value) {
			// probabile wheel

			this.wheel = true;
		} else {
			// Probabile touchpad
			this.wheel = false;
		}

		if (e.originalEvent.deltaY > 0) {
			// Scrolla giu
			let nextFrame = this.currentFrame + 1;
			if (nextFrame < this.sections.length) {
				this.showFrame(nextFrame, true);
			}
		} else {
			// Scrolla su
			let nextFrame = this.currentFrame - 1;
			if (nextFrame >= 0) {
				this.showFrame(nextFrame, false);
			}
		}
	}

	gotoSlide(quale) {
		if (quale > this.currentFrame) {
			this.showFrame(quale, true);
		} else if (quale < this.currentFrame) {
			this.showFrame(quale, false);
		}
	}

	showFrame(next, lGiu) {
		this.isScrolling = true;
		let frameDest = this.sections[next];
		let frameStart = this.sections[this.currentFrame];
		frameDest.show();
		if (lGiu) {
			frameStart.css("z-index", 2);
			frameDest.css("z-index", 1);
			frameDest.css("height", jQuery(window).height());
			TweenMax.to(frameStart, Main.TIME_SERRANDA, {
				height: 0,
				onComplete: this.serrandaCompleted.bind(this, next, frameStart),
			});
			this.preparaSlide(frameStart, frameDest);
			setTimeout(
				this.attivaSlide.bind(this, frameStart, frameDest),
				(Main.TIME_START_SLIDE_ANIMATION * 1000) / 2
			);
		} else {
			frameStart.css("z-index", 1);
			frameDest.css("z-index", 2);
			frameDest.css("height", 0);
			let h = jQuery(window).height();
			TweenMax.to(frameDest, Main.TIME_SERRANDA, {
				height: h,
				onComplete: this.serrandaCompleted.bind(this, next, frameStart),
			});
			this.preparaSlide(frameStart, frameDest);
			setTimeout(
				this.attivaSlide.bind(this, frameStart, frameDest),
				(Main.TIME_START_SLIDE_ANIMATION * 1000) / 2
			);
		}
		this.updatePallini(next);
	}

	serrandaCompleted(next, frameStart) {
		this.currentFrame = next;

		frameStart.hide();

		var lottiePrev = jQuery(frameStart).find("lottie-player")[0];
		if (lottiePrev) {
			lottiePrev.stop();
		}

		if (this.wheel) {
			this.enableScrolling();
		} else {
			setTimeout(this.enableScrolling.bind(this), 2000);
		}
	}

	enableScrolling() {
		this.isScrolling = false;
	}

	preparaSlide(frameStart, frameDest) {
		this.prepareAnimatedText({
			item: frameDest,
		});
		this.prepareItemInAlpha(
			{
				item: frameStart,
			},
			{
				item: frameDest,
			}
		);
	}

	attivaSlide(frameStart, frameDest) {
		this.killAnimation({
			item: frameStart,
		});

		this.showItemInAlpha({
			item: frameDest,
		});
		this.animateText({
			item: frameDest,
		});

		var lottieActive = jQuery(frameDest).find("lottie-player")[0];
		if (lottieActive) {
			lottieActive.play();
		}
	}
}

Main.ALWAYS_SCROLLBAR_CASE = true;
Main.DELAY_INIZIALE_ANIMAZIONE_TESTO = 0;
Main.DELAY_INIZIALE_ANIMAZIONE_APPEAR = 0.75;
Main.ENABLE_BACKGROUND_ANIMATION = false;

Main.TIME_SERRANDA = 0.5;
Main.TIME_START_SLIDE_ANIMATION = 0.2;
